import {MenuBadge} from 'platform/components';

import {isPositive} from 'ramda-adjunct';

import {GetDocumentContextCountApiArg, useGetDocumentContextCountQuery} from '@dms/api/core';

export function useDocumentContextCount(
  contextTarget: GetDocumentContextCountApiArg['contextTarget'],
  contextId: GetDocumentContextCountApiArg['contextId']
): MenuBadge | undefined {
  const {data: documentsCount} = useGetDocumentContextCountQuery(
    {
      contextTarget,
      contextId,
    },
    {skip: !contextId}
  );

  if (!isPositive(documentsCount?.count)) {
    return undefined;
  }

  return {
    colorScheme: 'neutral',
    value: documentsCount?.count ?? 0,
  };
}
